// PredictScoreModal
import React, {useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import IconModalCross from "../../../assets/images/eoro-2024/icon-modal-cross.svg";
import PredictScoreCard from "./PredictScoreCard";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {post} from "../../../Axios/post";
import {MATCH_DAY_SELECTIONS, PRE_TOURNAMENT_SELECTION, STAGING_BASE_URL} from "../../../Axios/EndPoints";
import ButtonLoader from "../../ButtonLoader";
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
// import {faTimes} from '@fortawesome/free-solid-svg-icons';

import border from "../../../assets/images/eoro-2024/thick-border.svg";

const PredictScoreModal = (props) => {
    const {
        isMobile,
        showModal,
        setShowModal,
        leagueId,
        matches,
        selectedMatchDay,
        fetchMatches,
    } = props;
    const [params] = useSearchParams();
    const user = useSelector(state => state?.Login);
    const [loading, setLoading]=useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    // const matchesArray = matches?.reduce((accumulator, currentDay) => {
    //     return accumulator.concat(currentDay.matches);
    // }, []);
    const matchesArray = matches?.reduce((accumulator, currentDay) => {
        const filteredMatches = currentDay.matches.filter(match => match.state === 3);
        return accumulator.concat(filteredMatches);
    }, []);
    // console.log("matches on PredictScore modal >>>", matchesArray)

    const [selections, setSelections] = useState(() => {
        // Create an array of selections based on matchesArray length
        return matchesArray?.map(match => ({
            match_id: match?.id, // Assuming match id is present in each match object
            local_team_score: match?.local_team?.prediction, // Initial value for local team score
            visitor_team_score: match?.visitor_team?.prediction, // Initial value for visitor team score
            joker_game: match?.is_joker || false, // Initial value for visitor team score
        }));
    });

    // console.log("selections on predict modal >>>>", selections)

    const handleJokerSelection = (matchId) => {
        setSelections(prevSelections =>
            prevSelections?.map(selection => ({
                ...selection,
                joker_game: selection?.match_id === matchId
            }))
        );
    };

    const submitPrediction = () => {
        const data = {
            league_id:leagueId,
            match_day_id:selectedMatchDay,
            selections:selections,
        }
        // console.log("data to submit >>>", data)
        setLoading(true);
        let isStaging = parseInt(params.get('staging'));
        post(MATCH_DAY_SELECTIONS, data, true, user?.token, null, isStaging ? STAGING_BASE_URL : '')
            .then((response) => {
                if (response?.data?.success) {
                    // console.log("response for Match Day selection >>", response?.data);
                    setShowModal(false);
                    fetchMatches();
                }
            })
            .catch((error) => {
                console.error('Match day selection error', error.response);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const handleSubmitClick = (e) => {
        e.preventDefault();
        const hasJokerGame = selections?.some(selection => selection?.joker_game);
        if (!hasJokerGame) {
            setShowConfirmation(true);
        } else {
            submitPrediction();
        }
    };

    const handleConfirmationResponse = (response) => {
        if (response === 'yes') {
            submitPrediction();
        }
        setShowConfirmation(false);
    };

    const render = () => {
        return (
            <>
                <Modal
                    show={showModal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    onHide={() => {
                        setShowModal(false)
                    }}
                    scrollable={true}
                >
                    <Modal.Header className={"p-0 m-0 px-3 py-2 d-flex flex-column border-0"}>
                        <div className={"d-flex justify-content-between align-items-center w-100 py-2"}>
                            <Modal.Title className={"fw-700 cabin font-25"}>Predict the score</Modal.Title>
                            <div className={"w-auto"} role={"button"} onClick={() => {
                                setShowModal(false)
                            }}>
                                <img
                                    src={IconModalCross}
                                    alt={"icon"}
                                    // className={"img-fluid"}
                                    height={25}
                                />
                            </div>
                        </div>
                        <div className={"w-75 d-flex align-items-center justify-content-center"}>
                            <div className={"w-100"}>
                                <img
                                    src={border}
                                    alt={"img"}
                                    className={"w-100 h-100"}
                                />
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {/*{showConfirmation ? (*/}
                        {/*    <div className={`d-flex flex-column gap-4`}>*/}
                        {/*        <div className={"cabin fw-500 font-20"}>Are you sure you want to make selections without a joker game?</div>*/}
                        {/*        <div className={"w-100 d-flex flex-row align-items-center justify-content-end"}>*/}
                        {/*            <div className={`d-flex w-50 gap-3`}>*/}
                        {/*                <Button*/}
                        {/*                    className="btn-skins-blue w-100"*/}
                        {/*                    onClick={() => handleConfirmationResponse('yes')}*/}
                        {/*                >*/}
                        {/*                    Yes*/}
                        {/*                </Button>*/}
                        {/*                <Button*/}
                        {/*                    className="btn-skins-red w-100"*/}
                        {/*                    onClick={() => handleConfirmationResponse('no')}*/}
                        {/*                >*/}
                        {/*                    No*/}
                        {/*                </Button>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*) : (*/}
                        {/*    <>*/}
                        {/*        <Row>*/}
                        {/*            {matchesArray?.map((match, index) => (*/}
                        {/*                <Col md={6} key={index}>*/}
                        {/*                    <PredictScoreCard*/}
                        {/*                        isMobile={isMobile}*/}
                        {/*                        match={match}*/}
                        {/*                        selection={selections?.find(selection => selection?.match_id === match?.id)}*/}
                        {/*                        setSelection={updatedSelection => {*/}
                        {/*                            setSelections(prevSelections => {*/}
                        {/*                                const updatedSelections = [...prevSelections];*/}
                        {/*                                const selectionIndex = prevSelections.findIndex(selection => selection.match_id === match.id);*/}
                        {/*                                updatedSelections[selectionIndex] = updatedSelection;*/}
                        {/*                                return updatedSelections;*/}
                        {/*                            });*/}
                        {/*                        }}*/}
                        {/*                        handleJokerSelection={handleJokerSelection}*/}
                        {/*                    />*/}
                        {/*                </Col>*/}
                        {/*            ))}*/}
                        {/*        </Row>*/}
                        {/*        <div className="text-center my-2">*/}
                        {/*            <Button*/}
                        {/*                className="btn-skins-red w-50"*/}
                        {/*                onClick={handleSubmitClick}*/}
                        {/*            >*/}
                        {/*                {loading ? <ButtonLoader loading={loading} /> : <>Submit</>}*/}
                        {/*            </Button>*/}
                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*)}*/}
                        <Row>
                            {matchesArray?.map((match, index) => (
                                <Col md={6} key={index}>
                                    <PredictScoreCard
                                        isMobile={isMobile}
                                        match={match}
                                        selection={selections?.find(selection => selection?.match_id === match?.id)}
                                        setSelection={updatedSelection => {
                                            setSelections(prevSelections => {
                                                const updatedSelections = [...prevSelections];
                                                const selectionIndex = prevSelections.findIndex(selection => selection.match_id === match.id);
                                                updatedSelections[selectionIndex] = updatedSelection;
                                                return updatedSelections;
                                            });
                                        }}
                                        handleJokerSelection={handleJokerSelection}
                                    />
                                </Col>
                            ))}
                        </Row>
                        <div className="text-center my-2">
                            <Button
                                className="btn-skins-red w-50"
                                onClick={submitPrediction}
                            >
                                {loading ? <ButtonLoader loading={loading} /> : <>Submit</>}
                            </Button>
                        </div>

                    </Modal.Body>
                </Modal>
            </>
        );
    }

    return render();
}

export default PredictScoreModal;
